import { waitForTruthyVal } from '../helpers/utils';
import { updateCart, cartSubject$ } from './cart.service';
const DY_DELIMITER = "::";
const DY_CART_ATTR = "_dy_variations";
/**
 * used to track page views in SPA
 */
export function trackPageView(route) {
    if (!route) {
        console.warn('route not defined; unable to track page view');
    }
    else {
        if (window.ga) {
            window.ga('set', 'page', route);
            window.ga('send', 'pageview');
        }
    }
}
export function pushToDataLayer(data) {
    if (window.dataLayer) {
        window.dataLayer.push(data);
    }
}
export function quantumMetricExists() {
    return !!window.QuantumMetricAPI;
}
/**
 * sends an event to QM
 */
export function quantumMetricEvent(eventId, isConversionEvent, eventValue) {
    if (quantumMetricExists()) {
        if (!eventId || ![0, 1].includes(isConversionEvent)) {
            console.error("both the event id and conversion indicator are needed to send QM event");
        }
        else {
            window.QuantumMetricAPI.sendEvent(eventId, isConversionEvent, eventValue);
        }
    }
}
export function emitShopifyEvent(name, payload = {}) {
    var _a, _b;
    console.debug("emitting shopify event", name, payload);
    (_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.publish(name, payload);
}
/**
 * sends an event to Dynamic Yield via DY.API
 * NOTE: we should try using the Experience API via web pixel before relying on this method
 */
export async function emitDynamicYieldEvent(name, payload = {}) {
    try {
        const api = await waitForTruthyVal(() => { var _a; return (_a = window.DY) === null || _a === void 0 ? void 0 : _a.API; });
        const eventData = {
            name: name,
            properties: payload
        };
        console.debug(`emitting dynamic yield event: ${JSON.stringify(eventData)}`);
        api('event', eventData);
    }
    catch (e) {
        console.warn("error with dy", e.message || e);
    }
}
/**
 * sends a single-page application event to Dynamic Yield
 * note: deprecated per DY docs: https://support.dynamicyield.com/hc/en-us/articles/360022956414--Deprecated-Single-Page-Applications-on-Websites
 */
export async function emitDynamicYieldSpaEvent(payload) {
    try {
        const api = await waitForTruthyVal(() => { var _a; return (_a = window.DY) === null || _a === void 0 ? void 0 : _a.API; });
        console.debug(`emitting dynamic yield SPA event: ${JSON.stringify(payload)}`);
        api('spa', payload);
    }
    catch (e) {
        console.warn("error with dy spa event", e.message || e);
    }
}
export function attachSessionIdsToCart() {
    waitForTruthyVal(() => { var _a; return typeof ((_a = window.QuantumMetricAPI) === null || _a === void 0 ? void 0 : _a.getSessionID) === 'function' && window.QuantumMetricAPI.getSessionID(); }, 500, 20)
        .then(() => {
        const params = {
            attributes: {
                qm_session_id: window.QuantumMetricAPI.getSessionID(),
                qm_user_id: window.QuantumMetricAPI.getUserID(),
            }
        };
        updateCart(params);
    }).catch(err => {
        console.warn("Could not get QM session/user data.", err);
    });
    waitForTruthyVal(getGA4Data, 500, 10)
        .then((data) => {
        var _a, _b;
        const params = {
            attributes: {
                ga_session_id: (_a = data.sessionData) === null || _a === void 0 ? void 0 : _a.shift(),
                ga_session_number: (_b = data.sessionData) === null || _b === void 0 ? void 0 : _b.shift(),
                ga_client_id: data.clientId
            }
        };
        updateCart(params);
    }).catch(err => {
        console.warn("Could not get GA data.", err);
    });
    setInterval(addDyInfo, 5000);
}
function getGA4Data() {
    // Extract Session ID from the _ga_{measurement id} cookie
    const sessionPattern = new RegExp(`_ga_${window.UNTUCKitConfig.ga4MeasurementId}=GS\\d\\.\\d\\.(.+?)(?:;|$)`);
    const sessionMatch = document.cookie.match(sessionPattern);
    const sessionParts = sessionMatch === null || sessionMatch === void 0 ? void 0 : sessionMatch[1].split(".");
    // Extract Client ID from the _ga cookie
    const clientIdPattern = new RegExp(`_ga=GA\\d\\.\\d\\.(\\d+\\.\\d+)(?:;|$)`);
    const clientIdMatch = document.cookie.match(clientIdPattern);
    const clientId = clientIdMatch === null || clientIdMatch === void 0 ? void 0 : clientIdMatch[1];
    if (!sessionParts || !clientId) {
        return null;
    }
    return {
        clientId: clientId,
        sessionData: sessionParts
    };
}
function addDyInfo() {
    var _a, _b, _c, _d;
    if (((_a = window.DYExps) === null || _a === void 0 ? void 0 : _a.otags) && ((_b = window.DYO) === null || _b === void 0 ? void 0 : _b.chosenVariations)) {
        const currentDyVariations = Object.entries(window.DYO.chosenVariations)
            .filter(entry => !!entry[1].smartObject)
            .map(entry => {
            var _a;
            const [campaignId, campaignInfo] = entry;
            const campaignName = convertDyString((_a = window.DYExps) === null || _a === void 0 ? void 0 : _a.otags[campaignId].displayName);
            const experienceName = convertDyString(campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.smartObject.name);
            if (!campaignName || !experienceName)
                return null;
            return campaignInfo.chosenVariations.map((variation) => `${campaignName}|${experienceName}|${convertDyString(variation.name)}`);
        }).flat().filter(v => !!v).sort();
        const existingDyVariations = (((_d = (_c = cartSubject$.getValue()) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d[DY_CART_ATTR]) || "").split(DY_DELIMITER).filter(s => !!s);
        if (!currentDyVariations.every(v => existingDyVariations.includes(v))) {
            const mergedDyVariations = Array.from(new Set(existingDyVariations.concat(currentDyVariations))).sort();
            console.log("updating DY info on cart", mergedDyVariations);
            updateCart({
                attributes: {
                    [DY_CART_ATTR]: mergedDyVariations.join(DY_DELIMITER)
                }
            });
        }
    }
}
/**
 * returns the Content Square global object. If it doesn't exist, it initializes it as an empty array.
 * @see: https://docs.contentsquare.com/en/web/#the-_uxa-object
 * @returns
 */
export function getCSQGlobal() {
    return window._uxa = window._uxa || [];
}
export const _forTesting = {
    addDyInfo
};
/**
 * converts a DY string to a readable format (sometimes the string is encoded)
 * @param string - the string to convert
 * @returns the converted string
 */
function convertDyString(string) {
    if (!string)
        return null;
    try {
        return decodeURIComponent(string);
    }
    catch (e) {
        return string;
    }
}
